// remove this whole component and corresponding folder when clean up the fg program_board_misc_improvements
import React from 'react';
import Badge from '@atlaskit/badge';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import { EPIC_STORY_POINT } from './constants.tsx';
import messages from './messages.tsx';

const EpicStoryPoint = ({
	value,
	workType,
}: {
	value: string | number | undefined;
	workType: string | undefined;
}) => {
	const { formatMessage, formatNumber } = useIntl();
	if (value === undefined) {
		return null;
	}

	const content = (() => {
		if (workType && expVal('jira-itr-m4-exp-3', 'isEnabled', false)) {
			return formatMessage(messages.tooltipIssueTerminologyRefreshM4, {
				workType,
			});
		}

		return formatMessage(
			expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
				? messages.tooltipIssueTermRefresh
				: messages.tooltip,
		);
	})();

	return (
		<Box paddingInlineEnd="space.025" testId={EPIC_STORY_POINT}>
			<Tooltip content={content} position="auto">
				{/* Supported prop in Atlaskit: https://atlassian.design/components/badge/code#style */}
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jira/react/no-style-attribute */}
				<Badge style={badgeStyles}>{formatNumber(Number(value))}</Badge>
			</Tooltip>
		</Box>
	);
};

export default EpicStoryPoint;

const badgeStyles = {
	backgroundColor: token('color.background.disabled'),
	color: token('color.text.disabled'),
};
